<template>
  <div class="col-12 g c col-lg-4">
    <br><br>
    <div class="card card-body">
        <img :src="require('@/assets/images/banner.png')" style="width: 50%; margin: 0px auto; padding: 20px" alt="">
        <div class="alert alert-danger text-center g" v-if="error">
            {{ error }}
        </div>
        <div class="form-group g">
          <h5 for="">اسم المستخدم</h5>
          <input type="text"
            class="form-control form-control-lg" v-model="phone">
        </div>
        <div class="form-group g">
          <h5 for="">كلمة المرور</h5>
          <input type="password"
            class="form-control form-control-lg" v-model="password">
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="login()">
                <i class="fa fa-sign-in"></i>
                تسجيل الدخول
            </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    created(){

    },
    data(){
        return {
            phone: "",
            password: "",
            error: null
        }
    },
    methods: {
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/admin/auth/login', {
                username: g.phone,
                password: g.password,
                type: 1
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("user", JSON.stringify(r.response))
                    window.location = '/'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>

<style>

</style>